import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

export interface DispatcherAssignmentDto {
  id: number;
  employeeDriverInfoId: number;
  dispatcherEmployeeId: number;
  startDate: string;
  endDate?: string;
  dispatcherFirstName?: string;
  dispatcherLastName?: string;
  dispatcherEmail?: string;
}

export interface UpdateDispatcherAssignmentsDto {
  dispatcherEmployeeIds: number[];
}

export const dispatcherAssignmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllDispatcherAssignments: builder.query<DispatcherAssignmentDto[], void>({
      query: () => "dispatcherassignments",
      transformResponse: unwrapApiResponse,
      providesTags: ["DispatcherAssignments"],
    }),

    getDispatcherAssignmentsByDriverId: builder.query<DispatcherAssignmentDto[], number>({
      query: (driverId) => `dispatcherassignments/${driverId}`,
      transformResponse: unwrapApiResponse,
      providesTags: (result, error, driverId) => [
        { type: "DispatcherAssignments", id: driverId },
        "DispatcherAssignments",
      ],
    }),

    updateDispatcherAssignments: builder.mutation<boolean, { driverId: number; dispatcherEmployeeIds: number[] }>({
      query: ({ driverId, dispatcherEmployeeIds }) => ({
        url: `dispatcherassignments/${driverId}`,
        method: "PUT",
        body: { dispatcherEmployeeIds },
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (result, error, { driverId }) => [
        { type: "DispatcherAssignments", id: driverId },
        "DispatcherAssignments",
        "TruckDrivers",
      ],
    }),
  }),
});

export const {
  useGetAllDispatcherAssignmentsQuery,
  useGetDispatcherAssignmentsByDriverIdQuery,
  useUpdateDispatcherAssignmentsMutation,
} = dispatcherAssignmentsApi;
